import { set } from 'lodash/fp';
import { handleSuccess, setOnSuccess, setOnResponse } from 'lp-redux-api';
import { selectorForSlice, setState, unsetState } from 'lp-redux-utils';
import { compose } from 'redux';
import { handleActions } from 'redux-actions';
import * as apiActions from '../apiActions';
import * as actions from './actions';
const reducerKey = 'creditApplication';
const slice = 'root.creditPortal.creditApplication';
const initialState = {
    proveApp: null,
    proveVerify: null,
    proveFail: null,
    proveBypass: undefined,
    offerScreen: 'PRESENTED OFFER',
    approveChargeFlowData: null,
};
const reducer = handleActions({
    [actions.clearProveFail.toString()]: unsetState('proveFail'),
    [actions.clearProveApp.toString()]: unsetState('proveApp'),
    [actions.clearProveVerify.toString()]: unsetState('proveVerify'),
    [actions.clearProveBypass.toString()]: unsetState('proveBypass'),
    [actions.setActiveOfferId.toString()]: setState('activeOfferId'),
    [actions.setOfferScreen.toString()]: setState('offerScreen'),
    [actions.setProveFail.toString()]: setState('proveFail'),
    [actions.setProveApp.toString()]: setState('proveApp'),
    [actions.setProveVerify.toString()]: setState('proveVerify'),
    [actions.setProveBypass.toString()]: setState('proveBypass'),
    [actions.setApplicationEnvironment.toString()]: setState('applicationEnvironment'),
    [actions.clearApplicationEnvironment.toString()]: unsetState('applicationEnvironment'),
    [actions.clearPractice.toString()]: unsetState('practice'),
    [actions.clearPracticeLocations.toString()]: unsetState('practiceLocations'),
    [actions.setPractice.toString()]: setState('practice'),
    [actions.setPersonalInfo.toString()]: setState('personalInfo'),
    [actions.setPersonalInfoOTA.toString()]: setState('personalInfoOTA'),
    [actions.setPracticesList.toString()]: setState('practicesList'),
    [actions.setPracticeLocations.toString()]: setState('practiceLocations'),
    [actions.setPrequalification.toString()]: setState('prequalification'),
    [actions.setLenderReferenceId.toString()]: setState('lenderReferenceId'),
    [actions.setLenderName.toString()]: setState('lenderName'),
    [actions.setCreditApplication.toString()]: setState('creditApplication'),
    [actions.clearPersonalInfo.toString()]: unsetState('personalInfo'),
    [actions.setApprovedApplication.toString()]: setState('approvedApplication'),
    [actions.setPendingDecisionDetails.toString()]: setState('pendingDecisionDetails'),
    [actions.setApproveChargeFlowData.toString()]: setState('approveChargeFlowData'),
    [actions.setSigningUrl.toString()]: setState('signingUrl'),
    [actions.clearApproveChargeFlowData.toString()]: unsetState('approveChargeFlowData'),
    [apiActions.applyAfterPrequalification]: setOnSuccess('approvedApplication'),
    [apiActions.submitFullApplication]: setOnSuccess('approvedApplication'),
    [apiActions.getPracticeLocations]: setOnSuccess('practiceLocations'),
    [apiActions.getCreditApplicationsByStatus]: handleSuccess((state, { payload: { data }, }) => {
        return compose(set('prequalifications', data.prequalifications), set('personalInfo', data.applicant))(state);
    }),
    [apiActions.searchForPractices]: setOnResponse('practicesList', 'practiceSearchError'),
}, initialState);
const select = selectorForSlice(slice);
const selectors = {
    activeOfferId: select('activeOfferId'),
    approveChargeFlowData: select('approveChargeFlowData'),
    approvedApplication: select('approvedApplication'),
    applicationEnvironment: select('applicationEnvironment'),
    creditApplication: select('creditApplication'),
    lenderName: select('lenderName'),
    lenderReferenceId: select('lenderReferenceId'),
    offerScreen: select('offerScreen'),
    pendingDecisionDetails: select('pendingDecisionDetails'),
    personalInfo: select('personalInfo'),
    personalInfoOTA: select('personalInfoOTA'),
    practice: select('practice'),
    practiceLocations: select('practiceLocations'),
    practiceSearchError: select('practiceSearchError'),
    practicesList: select('practicesList'),
    preQualificationData: select('preQualificationData'),
    prequalification: select('prequalification'),
    prequalifications: select('prequalifications'),
    proveApp: select('proveApp'),
    proveBypass: select('proveBypass'),
    proveFail: select('proveFail'),
    proveVerify: select('proveVerify'),
    signingUrl: select('signingUrl'),
};
export { reducer, selectors, reducerKey };
